import { tdsFetch, jsonToQuery } from '@/utils/fetch';

export const fetchCreate = (data) => {
  return tdsFetch('/project/add', { method: 'POST', body: data })
}

export const fetchInfo = (id) => {
  return tdsFetch(`/project/${id}`, { method: 'GET' })
}

export const fetchList = (data) => {
  return tdsFetch(`/project/list${jsonToQuery(data)}`, { method: 'GET' })
}

export const fetchDelete = (ids) => {
  return tdsFetch(`/project/delete`, { method: 'DELETE', body: ids })
}

export const fetchStatist = () => {
  return tdsFetch(`/project/statistics`, { method: 'GET' })
}

export const fetchUpload = (data, options) => {
  return tdsFetch('/project/file/upload', {
    ...options,
    method: 'POST',
    body: data
  })
}

export const extractImages = (id) => {
  return tdsFetch(`/project/file/${id}`, {
    method: 'get',
  })
}

export const fetchDeleteFile = (data) => {
  return tdsFetch('/project/file/batch/delete', {
    method: 'POST',
    body: data
  })
}

export const fetchDeleteByUrl = (data) => {
  return tdsFetch('/project/file/batch/deleteByUrl', {
    method: 'POST',
    body: data
  })
}

export const fetchDownload = (data) => {
  return tdsFetch('/project/file/zip', {
    method: 'POST',
    body: data,
    responseType: 'blob'
  })
}

export const fetchDownloadStructure = (data) => {
  return tdsFetch('/project/file/zip-structure', {
    method: 'POST',
    body: data,
    responseType: 'blob'
  })
}

export const fetchRecordList = (id) => {
  return tdsFetch(`/record/list?projectId=${id}`, {
    method: 'GET',
  })
}

export const fetchRecordAdd = (data) => {
  return tdsFetch(`/record/add`, {
    method: 'POST',
    body: data
  })
}

export const fetchWordUpload = (data) => {
  return tdsFetch(`/word/upload`, {
    method: 'POST',
    body: data
  })
}

export const fetchProjectFiles = (projectId) => {
  return tdsFetch(`/project/files/${projectId}`, {
    method: 'GET',
    responseType: 'blob'
  })
}

